import React from 'react'
import clsx from 'clsx'
import {Typography} from '../components/Typography'
import depoimentoImg from '../img/depoimentos.png'
import {useDepoimentosQuery} from '../utils/hooks/useDepoimentosQuery'

const Depositions = () => {
  const [random, setRandom] = React.useState(null)
  const depoimentos = useDepoimentosQuery()

  React.useEffect(() => {
    setRandom(Math.floor(Math.random() * depoimentos.length))
  }, [])

  return (
    <div className="my-8 bg-gray-100 bg-opacity-10">
      <div className="mx-auto max-w-screen-xl">
        <div className="py-16 lg:px-32">
          {random !== null &&
            depoimentos.map(
              (
                {photo, name, job, locale, coursesComplete, depoimento},
                index,
              ) => (
                <div
                  className={clsx(
                    'space-x-12 flex-col items-center space-y-6 lg:space-y-0 lg:flex-row',
                    random !== index ? 'hidden' : 'flex',
                  )}
                >
                  <img src={photo} className="w-32 h-32 rounded-full" />
                  <div className="flex pr-8 lg:pr-0 ">
                    <Typography variant="heading">"</Typography>
                    <span className="space-y-2">
                      <Typography size="lg" className="mt-2">
                        {depoimento}"
                      </Typography>
                      <Typography>
                        {name}, {job}, {locale}
                      </Typography>
                      <Typography>
                        Cursos feitos:{' '}
                        <Typography as="span" weight="black">
                          {coursesComplete}
                        </Typography>
                      </Typography>
                    </span>
                  </div>
                </div>
              ),
            )}
        </div>
      </div>
    </div>
  )
}

export {Depositions}
